import imageTijuana from '../resources/images/estrategas/places/logo-tijuana.png';
import imageCuliacan from '../resources/images/estrategas/places/logo-culiacan.png';
import imageVallarta from '../resources/images/estrategas/places/logo-vallarta.jpeg';

export default function () {
  return [
    {
      id: 1,
      imgUrl: imageCuliacan,
      name:'Culiacán'
    },
    {
      id: 2,
      imgUrl: imageVallarta,
      name:'Vallarta'
    },
    {
      id: 3,
      imgUrl: imageTijuana,
      name:'Tijuana'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/reducers/placesReducers.js